import Entry from './Entry';

export default Entry;
